import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { TriggerTypes } from "src/app/models/api/playbooks/triggers/triggerTypes.enum";
import { PlaybooksActionDefinitionInput } from "src/app/models/componentInputs/playbookActionInput.interface";
import { PlaybooksTriggerActionsService } from "src/app/services/actions/playbooks/playbooks-trigger-actions/playbooks-trigger-actions.service";

@Component({
    selector: "app-secure-flow-steps-action",
    templateUrl: "./secure-flow-steps-action.component.html",
    styleUrls: ["./secure-flow-steps-action.component.scss"],
})
export class SecureFlowStepsActionComponent {
    @Input() public fg: UntypedFormGroup;
    @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
    @Input() public triggerType: TriggerTypes;
    public supportedRulesIdAndDescription: string[] = [];

    private _supportedRules = new Set<string>(["ZN_P00095", "ZN_P00099", "ZN_P00103", "ZN_P00108", "ZN_P00112", "ZN_P00117", "ZN_P00121"]);

    constructor(private _playbooksTriggerActionsService: PlaybooksTriggerActionsService) {
        this.supportedRulesIdAndDescription = _playbooksTriggerActionsService
            .getRulesByIds(this._supportedRules)
            .map((rule) => `${rule.id} - ${rule.displayName}`);
    }
}
